import React from 'react';
import { VendorCtaSelectorProps } from './VendorCtaSelector';

const CarnowCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  return (
    // eslint-disable-next-line
    <div
      className="cn-button-container"
      data-vin={vin}
      data-page-type={ctaDetails.pagePlacementTypeCarnow}
      data-type="new"
      data-testid="carnow"
    ></div>
  );
};

export default CarnowCta;
